import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SwitchIconButton from "@/components/buttons/SwitchIconButton/SwitchIconButton.vue";
import { AuthMutationTypes } from "@/store/auth";
import { IconType } from "@/types/icons";
import { Room } from "twilio-video";
import { useStore } from "vuex";

interface Props {
  room: Room | null;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'HangUpButton',
  props: {
    room: { default: null }
  },
  setup(__props: any) {

const props = __props;

const { commit } = useStore();

const handleHangUp = () => {
  if (!props.room) {
    return;
  }
  commit(AuthMutationTypes.SET_CURRENT_ONGOING_CALL_ID, null);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SwitchIconButton, {
    "active-icon": _unref(IconType).CONTROL_HANG_UP,
    "hover-icon": _unref(IconType).CONTROL_HANG_UP_HOVER,
    onClick: handleHangUp
  }, null, 8, ["active-icon", "hover-icon"]))
}
}

})